import { AnyObject, CardStructureConfig, ItemAttrListDataSet } from '@mri/types';

export function cardGetTitleRender(prop: ItemAttrListDataSet, structure: CardStructureConfig<AnyObject>): string {
  return structure.title(prop);
}
